<template>
  <app-layout>
    <Head title="Keywords"/>
    <template #header>
      <div class="md:flex justify-between items-center pb-1">
        <div class="mr-4 md:mr-5 flex justify-start items-center">
          <PageBackHeader href="/keywords" label="Keywords">
            <template #subtitle>
              <p class="text-gray-600 font-semibold text-xl uppercase">{{ keywordDetails.keyword }}</p>
            </template>
          </PageBackHeader>
        </div>
      </div>
    </template>

    <div class="max-w-7xl mx-auto flex mb-6">
      <div class="w-full p-2 sm:px-6 lg:px-8">
        <div class="grid grid-cols-12 gap-6">
          <div class="col-span-12 lg:col-span-4">
            <div class="bg-white shadow-xl p-4 sm:rounded-lg sm:p-6 lg:p-8">
              <div class="flex justify-between mb-5">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">Keyword Details</h2>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Keyword</div>
                <p class="uppercase">{{ keywordDetails.keyword }} </p>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Contacts subscribed</div>
                <p>{{ this.keywordDetails.contacts.length }}</p>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Associated List</div>
                <Link
                  :href="route('groups.view', keywordDetails.group.group.tra_id)"
                  class="text-blue-600"
                >{{ keywordDetails.group.group.title }}</Link
                >
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Create Date</div>
                <p><date-tooltip :data="keywordDetails.created_at" /></p>
              </div>
              <div class="mb-5">
                <div class="text-gray-600">Unsubscribes</div>
                <p>{{ getUnsubscribesCount }}</p>
              </div>
              <div class="text-center">
                <div class="sm:inline-block">
                  <button class="text-gray-700 focus:outline-none" @click="toggleDeletionModal(keywordDetails.id)">
                    Delete Keyword
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-12 lg:col-span-8">
          <div class="flex justify-between border-b-2 pb-3">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-2">History</h2>
              </div>
            <div class="history overflow-auto" style="max-height:560px;">
              <div class="bg-white shadow-sm p-2 sm:rounded-lg sm:p-6 lg:p-8 mt-5">
                <div class="msg-box">
                  <div class="flex justify-between ">
                    <p class="font-bold text-gray-900 mb-2">Keyword was added on</p>
                    <span class="text-gray-600"><date-tooltip :data="keywordDetails.created_at" /></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <jet-dialog-modal v-if="showDeletionModal" :show="showDeletionModal" @close="showDeletionModal = false">
      <template #title>
        Delete keyword
      </template>

      <template #content>
        Are you sure you want to delete this keyword?
      </template>

      <template #footer>
        <jet-secondary-button @click="toggleDeletionModal">
          Cancel
        </jet-secondary-button>
        <jet-danger-button class="ml-2" @click.native="deleteKeyword(keywordDetails.id)">
        Delete keyword
        </jet-danger-button>
      </template>
    </jet-dialog-modal>
  </app-layout>
</template>

<script>
import axios from "axios";

const IS_DO_NOT_CONTACT = 1;

import AppLayout from "../../Layouts/AppLayout";
import JetDropdown from "../../Jetstream/Dropdown";
import JetDropdownLink from "../../Jetstream/DropdownLink";
import JetDialogModal from "../../Jetstream/DialogModal";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetNavLink from "../../Jetstream/NavLink";
import Button from "../../Jetstream/Button";
import JetDangerButton from "../../Jetstream/DangerButton";
import DateTooltip from '../../components/DateTooltip.vue'

export default {
  components: {
    AppLayout,
    JetDropdown,
    JetDropdownLink,
    JetDialogModal,
    JetNavLink,
    Button,
    JetSecondaryButton,
    JetDangerButton,
    DateTooltip
  },
  props: {
    keywordDetails: Object
  },
  data() {
    return {
      showDeletionModal: false,
      showEditModal: false,
      contactEditDetails: {
        first_name: null,
        last_name: null,
        phone_number: null,
        id: null
      },
      contactSetForDeletion: null,
      contactMessages: [],
    };
  },
  mounted(){
    this.formatCreatedAtDate();
  },
  computed: {
    getUnsubscribesCount() {
      return this.keywordDetails.contacts
        .filter(contact => contact.do_not_contact === IS_DO_NOT_CONTACT).length;
    },
  },
  methods: {
    formatCreatedAtDate() {
      this.keywordDetails.created_at =  new Date(this.keywordDetails.created_at)
        .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    },
    toggleDeletionModal(row) {
      if (!this.showDeletionModal) {
        this.contactSetForDeletion = row;
      }
      this.showDeletionModal = !this.showDeletionModal;
      document.body.style.overflow = null
    },
    deleteKeyword(id) {
      let vm = this;
      axios
        .post(`/keywords/delete/${id}`, {
          redirectToKeywords: true
        })
        .then(function(res) {
          vm.$inertia.visit("/keywords")

          vm.$toasted.show(res.data, {
            position: "bottom-right",
            type: "success",
            duration: 3000
          });
        })
        .catch(function(err) {
          vm.$inertia.visit("/keywords");
          vm.$toasted.show(err.response.data.message, {
            position: "bottom-right",
            type: "error",
            duration: 3000
          });
        });
        document.body.style.overflow = null
    },
  }
};
</script>
